// extracted by mini-css-extract-plugin
export default {"pagenotfound":"pagenotfound_pagenotfound__fgZ-4","pagenotfoundheading":"pagenotfound_pagenotfoundheading__j42Pl"};